import ViewDialog from './ViewDialog'

export default ViewDialog
